import React from "react";
import PropTypes from "prop-types";
import { Paragraph } from "components/core/Typography";

import "./ReviewCard.scss";
import { Calendar } from "components/core/Icons";
import { StarRating } from "components/review/StarRating";
import { Heading } from "components/storages/Common";

const ReviewCard = ({
	title,
	nickname,
	date,
	rating,
	message,
	hideHeading,
	hideRatingText
}) => (
	<div className="review-card">
		<div className="review-header">
			<div className="review-card--header">
				{hideHeading ? (
					<span className="sf-type sf-heading size-standard weight-bold title last">
						{title}
					</span>
				) : (
					<Heading
						className="title last"
						content={title}
						size="standard"
						level="3"
					/>
				)}
				<div className="meta">
					<Paragraph
						size="small"
						last
						className="author"
					>
						{`by ${nickname}`}
					</Paragraph>
					<Paragraph
						size="small"
						last
						className="date"
					>
						<Calendar />
						<span>{date}</span>
					</Paragraph>
				</div>
			</div>
			<div className="review-rating-wrapper">
				<StarRating
					outOf={5}
					rating={rating}
					withLabel={!hideRatingText}
				/>
				{hideRatingText && (
					<span className="review-rating-number">
						{rating.toFixed(1)}
					</span>
				)}
			</div>
		</div>
		<div className="review-card--content">
			<Paragraph last>{message}</Paragraph>
		</div>
	</div>
);

ReviewCard.defaultProps = {
	title: "",
	nickname: "",
	message: ""
};

ReviewCard.propTypes = {
	title: PropTypes.string,
	nickname: PropTypes.string,
	date: PropTypes.string.isRequired,
	rating: PropTypes.number.isRequired,
	message: PropTypes.string,
	hideHeading: PropTypes.bool,
	hideRatingText: PropTypes.bool
};

export default ReviewCard;
